import { CFormInput, CLoadingButton } from "@coreui/react-pro";
import Header from "../components/Header";
import { useState } from "react";
import axios from "@/shared/config/axios-interceptor";
import { ToastInfo, ToastSuccess } from "@/components/shared/toast/Toast";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/reducers";
import { AppDispatch } from "@/store";
import { getProfile } from "../../auth/auth.api";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MatKhauRutTien = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.authentication);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const onSubmit = async () => {
    if (!newPassword || !confirmNewPassword) {
      ToastInfo(t("Vui lòng nhập đầy đủ thông tin!"));
      return;
    }
    try {
      setLoading(true);
      await axios.put("/user/change-paypassword", {
        currentPassword,
        newPassword,
        confirmNewPassword,
      });
      ToastSuccess(t("Đổi mật khẩu thành công!"));
      setCurrentPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
      dispatch(getProfile());
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  console.log(user);
  return (
    <div className="wrapper">
      <div className="container-web matkhaudangnhap bgnew">
        <Header title={t("Mật khẩu rút tiền")} />
        <main>
          {user?.paypassword && (
            <div className="form-group">
              <CFormInput
                type="password"
                label={t("Mật khẩu cũ")}
                placeholder={t("Vui lòng nhập mật khẩu cũ")}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
            </div>
          )}

          <div className="form-group">
            <CFormInput
              type="password"
              label={t("Mật khẩu mới")}
              placeholder={t("Vui lòng nhập 4 chữ số")}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>

          <div className="form-group">
            <CFormInput
              type="password"
              label={t("Xác nhận mật khẩu mới")}
              placeholder={t("Vui lòng nhập 4 chữ số")}
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
            />
          </div>

          <p className="text-end px-3 mt-3" style={{ fontSize: 12 }}>
            {" "}
            {t("Không có phương thức xác minh tài khoản, vui lòng quên mật khẩu cũ")} <Link to="/cskh" className="text-white">{t("Liên hệ CSKH")}</Link>
          </p>

          <div className="px-3">
            <CLoadingButton
              onClick={onSubmit}
              className="w-100 rounded-1"
              loading={loading}
              disabled={loading}
            >
              {t("Xác nhận")}
            </CLoadingButton>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MatKhauRutTien;
